import {Component, OnDestroy, OnInit} from '@angular/core';
import {Login} from '../../../modelo/usuario/login';
import {SubscriptionLike} from 'rxjs';
import {Producto} from '../../../modelo/producto/producto';
import {UserloginService} from '../../../servicios/usuario/userlogin.service';
import {ActivatedRoute} from '@angular/router';
import {ProductoService} from '../../../servicios/producto/producto.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Adicional} from '../../../modelo/producto/adicional';
import {PoliticaVenta} from '../../../modelo/producto/politica-venta';
import {NotificacionesService} from '../../../servicios/utilidades/notificaciones.service';
import {DeseadoService} from '../../../servicios/producto/deseado.service';
import {CarritoService} from '../../../servicios/pedido/carrito.service';
import {finalize, tap} from 'rxjs/operators';
import {CarMarcaService} from '../../../servicios/soporte/car-marca.service';
import {CarMarca} from '../../../modelo/soporte/car-marca';
import {MatDialog} from "@angular/material/dialog";
import {
  MarcaDescripcionEmergenteComponent
} from "../../../ui/modals/marca-descripcion-emergente/marca-descripcion-emergente.component";
import {ProductoImagen} from "../../../modelo/producto/producto-imagen";
import {ProductoImagenService} from "../../../servicios/producto/producto-imagen.service";

@Component({
  selector: 'app-ver-producto',
  templateUrl: './ver-producto.component.html',
  styleUrls: ['./ver-producto.component.css']
})
export class VerProductoComponent implements OnInit, OnDestroy {
  public currentUser: Login;
  private subs: SubscriptionLike[];
  public producto: Producto;
  private art_codtext: string;
  private art_codnum: string;
  public buscando: boolean;

  public clicodigo: string;
  private idUsuario: string;
  public video: SafeHtml;
  public cantidad: number;
  public politicaSelect: PoliticaVenta;
  public marca: CarMarca;
  public productoImag: ProductoImagen[];

  public isAdmin: boolean = false;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];


  constructor(private userLogin: UserloginService, private routerAc: ActivatedRoute, private prodSV: ProductoService,
              private domSanitizer: DomSanitizer, private noti: NotificacionesService, private desSV: DeseadoService,
              private carSV: CarritoService, private soporteSV: CarMarcaService, public dialog: MatDialog, public productoImagenSV: ProductoImagenService) {
    this.currentUser = null;
    this.subs = [];
    this.cantidad = 1;
    this.politicaSelect = null;
    this.buscando = true;
    this.marca = null;
    this.productoImag = [];
  }

  ngOnInit(): void {
    this.userLogin.currentUser.subscribe(res => {
      this.currentUser = res;
      this.isAdmin = this.currentUser != null ? this.currentUser.usuario == 'Admin' : false;
      this.clicodigo = this.currentUser != null ? this.currentUser.cliCodigo : '0';
      this.idUsuario = this.currentUser != null ? this.currentUser.idUsuario : '-1';
    })
    this.subs.push(
      this.routerAc.params.subscribe(parm => {
        this.art_codtext = parm.codtext;
        this.art_codnum = parm.codnum;
        this.buscando = true;
        this.subs.push(
          this.prodSV.consultarProducto(this.clicodigo, this.art_codtext, this.art_codnum, this.idUsuario)
            .pipe(
              tap(() => this.producto = null),
              finalize(() => {
                this.buscando = false;
              })
            )
            .subscribe(res => {
                this.producto = res.data;
                this.traerImagenMarca();
                this.traerImagenProducto();
                if (this.producto.url_video != null && this.producto.url_video!="") {
                  this.mostrarVideo();
                }
              }
            ));
      }));
  }

  showMensaje(mensaje: string, tipo: string) {
    let clasname: string = '';
    switch (tipo) {
      case 'error':
        clasname = 'bg-danger text-light';
        break;
      case 'exito':
        clasname = 'bg-success text-light';
        break;
      default:
        clasname = 'bg-info text-light';
        break;
    }

    this.noti.show(mensaje, {classname: clasname, delay: 5000, autohide: true});
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }


  generarURL() {
    if (this.producto.adicionalSeleccionado != null) {
      if (this.producto.adicionalSeleccionado.art_adicional.indexOf('/')) {
        return this.producto.art_codtex + '' + this.producto.art_codnum + '' + this.producto.adicionalSeleccionado.art_adicional.replace('/', '');
      }
      return this.producto.art_codtex + '' + this.producto.art_codnum + '' + this.producto.adicionalSeleccionado.art_adicional;
    }
    return this.producto.art_codtex + '' + this.producto.art_codnum;
  }

  calcularTotal() {
    let total = 0;
    if (this.producto.oferta.length > 0 && this.cantidad >= this.producto.oferta[0].minimo) {
      total = this.producto.resultado * this.cantidad;
    } else if (this.politicaSelect != null) {
      const prec = (this.producto.precioFinal * (parseFloat(this.politicaSelect.dtoPV.replace('-', '')))) / 100;
      total = (this.producto.precioFinal - prec) * this.cantidad;
    } else {
      total = this.producto.precioFinal * this.cantidad;
    }
    return total;
  }

  selectPoliticaVTA() {
    this.politicaSelect = null;
    for (const element of this.producto.descuento) {
      if (this.cantidad >= element.cantMin) {
        this.politicaSelect = element;
      }
    }
  }

  mostrarVideo() {
    this.video = this.domSanitizer.bypassSecurityTrustHtml(this.producto.url_video);
  }

  compararFuncionCondicionIva(ad: Adicional, ad2: Adicional) {
    return ad.adicional == ad2.adicional && ad.art_adicional == ad2.art_adicional;
  }

  selectPolitica(d: PoliticaVenta) {
    this.cantidad = d.cantMin;
    this.politicaSelect = d;
  }

  calcularPrecio() {
    let total = this.producto.precioFinal;
    if (this.politicaSelect != null) {
      const prec = (this.producto.precioFinal * (parseFloat(this.politicaSelect.dtoPV.replace('-', '')))) / 100;
      total = (this.producto.precioFinal - prec);
    }
    return total;
  }

  calcularPrecioSinImpuesto():number{
    const tasaImpuesto = parseFloat(this.producto.art_aliva) / 100; // Convertir porcentaje a decimal
    return this.producto.precioFinal / (1 + tasaImpuesto);
  }

  aniadirDesaseado() {
    if (!this.producto.deseado) {
      this.subs.push(
        this.desSV.aniadirDeseado(this.producto.art_codtex, this.producto.art_codnum, this.idUsuario).subscribe(res => {
          this.showMensaje(res.status_message, 'exito');
          this.producto.deseado = true;
          this.desSV.listarCantidadDeseados(this.idUsuario);
        }, error => {
          this.showMensaje(error.status_message, 'error');
        })
      );

    } else {
      this.subs.push(
        this.desSV.eliminarDeseado(this.producto.art_codtex, this.producto.art_codnum, this.idUsuario).subscribe(res => {
          this.showMensaje(res.status_message, 'exito');
          this.producto.deseado = false;
          this.desSV.listarCantidadDeseados(this.idUsuario);
        }, error => {
          this.showMensaje(error.status_message, 'error');
        })
      );

    }
  }

  aniadirCarrito() {
    if (this.idUsuario != '-1') {
      const adi = this.producto.adicionalSeleccionado != null ? this.producto.adicionalSeleccionado.art_adicional : '';
      this.subs.push(
        this.carSV.agregarElementon(this.clicodigo, this.producto.art_codtex, this.producto.art_codnum, adi, this.cantidad, this.producto.precio,parseInt(this.idUsuario)).subscribe(
          res => {
            this.showMensaje(res.status_message, 'exito');
            this.carSV.listarCantidadElementos(this.idUsuario);
          }, error => {
            this.showMensaje(error.status_message, 'error');
          }
        )
      )
    }
  }

  private traerImagenMarca() {
    this.subs.push(
      this.soporteSV.traerMarca(this.producto.art_codtex).subscribe(res => {
        this.marca = res.data;
      })
    )
  }

  private traerImagenProducto() {
    this.subs.push(
      this.productoImagenSV.listarImagenProducto(this.producto.art_codtex, this.producto.art_codnum).subscribe(res => {
        this.productoImag = res.data;
        if (this.productoImag.length > 0) {
          this.cargarImagenDefault();
        }
      })
    )
  }

  private cargarImagenDefault() {
    if (this.producto.adicionales.length > 0) {
      for (const adicional of this.producto.adicionales) {
        let imgUrl = '';
        if (adicional.art_adicional.indexOf('/')) {
          imgUrl = this.producto.art_codtex + '' + this.producto.art_codnum + '' + adicional.art_adicional.replace('/', '');
        } else {
          imgUrl = this.producto.art_codtex + '' + this.producto.art_codnum + '' + adicional.art_adicional;
        }
        let productImagen: ProductoImagen = {
          idArticuloImagen: 88,
          artCodtex: this.producto.art_codtex,
          artCodnum: this.producto.art_codnum,
          urlImagen: "https://melectricidad.com.ar/images/productosSistemas/" + imgUrl
        }
        this.productoImag.unshift(productImagen)
      }
    } else {
      let productImagen: ProductoImagen = {
        idArticuloImagen: 88,
        artCodtex: this.producto.art_codtex,
        artCodnum: this.producto.art_codnum,
        urlImagen: "https://melectricidad.com.ar/images/productosSistemas/" + this.producto.art_codtex + this.producto.art_codnum
      }
      this.productoImag.unshift(productImagen)
    }
  }

  public incrementar() {
    this.cantidad++;
    this.selectPoliticaVTA();
  }

  public disminuir() {
    this.cantidad--;
    this.selectPoliticaVTA();
  }

  public infoMarca() {
    if (this.marca.descripcion_publicidad != undefined && this.marca.descripcion_publicidad.length > 0) {
      this.dialog.open(MarcaDescripcionEmergenteComponent, {
        data: this.marca.descripcion_publicidad,
        panelClass: 'dialog-marca-descripcion',
        hasBackdrop: false,
        position: {
          bottom:'150px'
        }
      });
    }
  }

  generarURLWA() {
    return this.domSanitizer.bypassSecurityTrustUrl('whatsapp://send?text=Hola, me gustaría que echarás un vistazo al siguiente producto. ' + location.href);
  }

  generarURLFA() {
    return this.domSanitizer.bypassSecurityTrustUrl('https://www.facebook.com/sharer.php?u=' + location.href)
  }

  noTag(){
    return this.producto.chips!="";
  }
  isMasVendido(){
    return this.producto.chips=="MÁS VENDIDO";
  }
  isNewMasVendido(){
    return this.producto.chips=="NEW,MÁS VENDIDO";
  }

  isNew(){
    return this.producto.chips.includes("NEW");
  }
  isLiquidacion(){
    return this.producto.chips=="LIQUIDACIÓN";
  }
  isProximamente(){
    return this.producto.chips=="PROXIMAMENTE";
  }
  // isBotonCompraVisible(){
  //   return (this.currentUser!=null && this.clicodigo !== '0') && (this.clicodigo !== '10780' || this.producto.precioVisible==='1');
  // }
  isBotonCompraRedirect(){
    return (this.currentUser!=null && this.clicodigo !== '0');
  }
}
